module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/milk-shake@3x_55e502.jpg";